import React, { ComponentProps } from 'react';
import { TableCell as CarbonTableCell } from '@carbon/react';

export type TableCellProps = ComponentProps<typeof CarbonTableCell>;

export const TableCell = (props: TableCellProps) => (
  <CarbonTableCell {...props} />
);

TableCell.displayName = 'TableCell';
